import React from 'react'
import css from './Footer.module.css';

const Footer = () => {
    return (
        <div className={css.FooterContent}>
            <span><a href="https://www.cpatu.com.uy/radio-taxi-141/#" target="_blank" rel="noopener noreferrer">Cpatu Radio Taxi 141</a> </span>
            <span>Web creada por <a href="http://www.endata.com.ar/" target="_blank" rel="noopener noreferrer">Endata SRL</a> </span>
        </div>
    )
}

export default Footer
